<template>
    <div class="container">
        <AppSection :title="params.message.title" class="section-tasks-categories" :b_bottom="params.b_bottom">
            <template #header_left v-if="params.header_left">
                <div v-html="params.header_left"></div>
            </template>
          <template #header_right v-if="params.header_right">
            <a v-if="params.header_right.link" :href="params.header_right.link">{{params.header_right.title}}</a>
          </template>
            <template #body>
                <div class="grid">
                    <task-category-card
                        v-for="(item, i) in params.items"
                        :key="i"
                        v-bind="item"
                        :translates="params.translates"
                    />
                </div>
            </template>
        </AppSection>
    </div>
</template>

<script>
import AppSection from '../AppSection.vue'
import TaskCategoryCard from '../cards/TaskCategoryCard.vue'
import SliderCards from '../SliderCards.vue'
import {SwiperSlide} from 'swiper/vue';

export default {
    name: 'CategoriesSection',
    props: {
        params: {
            type: Object,
            default: () => {
            }
        }
    },
    components: {
        AppSection,
        TaskCategoryCard,
        SliderCards,
        SwiperSlide,
    },
    setup: (props, ctx) => {

        return {}
    },
}
</script>

<style lang="scss">
.section-tasks-categories {

    .grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(1px, 1fr));
        gap: 30px;

        @include tablet {
            gap: 20px;
        }

        @include mobile {
            grid-template-columns: 100%;
            gap: 10px;
        }
    }

    @media (min-width: 1024px) {
        .swiper {
            overflow: visible;
            margin-bottom: -30px;

            &-wrapper {
                max-width: initial;
                width: auto;
                flex-wrap: wrap;
                margin: 0 -15px;
            }

            &-slide {
                padding: 0 15px;
                width: 16.666666% !important;
                margin-right: 0 !important;
                margin-bottom: 30px;
            }
        }
        .slider-cards__btns {
            display: none;
        }
    }
    @include tablet {
        .swiper {
            padding-top: 30px;
            padding-bottom: 30px;
            margin-top: -30px;
            margin-bottom: -30px;
        }
    }
}
</style>